"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createItemConfigObject = createItemConfigObject;
exports.getApplicableTerm = void 0;

var _Terms = require("self-service-api/constants/Terms");

// If the desired term is unavailable, return the available term instead
var getApplicableTerm = function getApplicableTerm(desiredTerm, availableTermsMap) {
  if (!availableTermsMap[desiredTerm]) {
    return desiredTerm === _Terms.MONTHLY ? _Terms.ANNUAL : _Terms.MONTHLY;
  }

  return desiredTerm;
};

exports.getApplicableTerm = getApplicableTerm;

function createItemConfigObject(_ref) {
  var merchandiseId = _ref.merchandiseId,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity;
  return {
    merchandiseId: merchandiseId,
    quantity: quantity
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/itemConfigUtils.js
// module id = 75
// module chunks = 5 6 7